<template>

    <b-card>
        <div class="alert alert-warning" v-if="hasInvalidDate">
            <b>Warning!</b> Invalid Date.
        </div>
        <b-row>

            <b-col sm="6" class="d-flex align-items-center justify-content-between my-1">

                <date-picker
                    v-model="startDate"
                    placeholder="Start Date"
                    class="f-1">
                </date-picker> &nbsp;to&nbsp;
                <date-picker
                    v-model="endDate"
                    placeholder="End Date"
                    class="f-1">
                </date-picker>
            </b-col>
        </b-row>

        <b-row class="my-2">

            <b-col class="text-right">

                <b-button variant="info" @click=" loadTable() ">Load Visits</b-button>
            </b-col>
        </b-row>

        <div class="table-responsive">

            <b-table bordered striped hover show-empty
                :sort-by.sync=" sortBy "
                :sort-desc.sync=" sortDesc "
                :items=" items "
                :fields=" fields "
                :busy=" loading "
            >
                <template v-slot:cell(checked_in_time)="row">
                  <utc-time :timezone="row.item.shift_timezone" :time="row.item.checked_in_time" format="MM/DD/YYYY" />
                </template>
                <template v-slot:cell(clocked_in)="row">
                  <utc-time :timezone="row.item.shift_timezone" :time="row.item.checked_in_time" format="hh:mm A" />
                </template>
                <template v-slot:cell(clocked_out)="row">
                  <utc-time :timezone="row.item.shift_timezone" :time="row.item.checked_out_time" format="hh:mm A" />
                </template>
                <template v-slot:cell(duration)="row">
                   {{  calculateTimeDifference(row.item.checked_in_time, row.item.checked_out_time) }} 
                </template>
                <template v-slot:cell(invoice)="row">
                    {{ row.item.invoice ? row.item.invoice.name : 'Pending' }}
                </template>
                <template v-slot:cell(submission)="row">
                    {{ formatSubmission(row.item) }}
                </template>
                <template v-slot:cell(verified)="row">
                    {{ row.item.verified ? 'Verified' : 'Unverified' }}
                </template>
                <template v-slot:cell(flags)="row">
                    <shift-flag-icons :flags="row.item.flags" />
                </template>
                <template v-slot:cell(total)="row">
                    {{ determineDisplayTotal(row.item) }}
                </template>
                <template v-slot:cell(visit_status)="row">
                    {{ determineVisitStatus(row.item) }}
                </template>
                <template v-slot:cell(actions)="row">
                    <!--<b-btn @click="details(row.item)">View</b-btn>-->
                    <b-btn :href="'/client/shifts/' + row.item.id" variant="secondary" target="_blank">View</b-btn> &nbsp;&nbsp;
                    <p v-if="row.item.status != 'CLOCKED_IN'">
                        <b-btn :href="'/client/shifts/' + row.item.id + '?dispute=1'" variant="danger" target="_blank">Modify</b-btn>
                    </p>
                </template>
            </b-table>
        </div>

        <b-row>

            <b-col lg="6">

                <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
            </b-col>
            <b-col lg="6" class="text-right">

                {{ paginationText }}
            </b-col>
        </b-row>

        <b-modal id="detailsModal" title="Shift Details" v-model="detailsModal" size="lg">
            <b-container fluid>
                <b-row class="with-padding-bottom">
                    <b-col sm="6">
                        <strong>Claimant</strong>
                        <br />
                        {{ client.name }}
                    </b-col>
                    <b-col sm="6" v-if="selectedItem.caregiver">
                        <strong>Provider</strong><br />
                        {{ selectedItem.caregiver.name }}
                    </b-col>
                </b-row>
                <b-row class="with-padding-bottom">
                    <b-col sm="6">
                        <strong>Checked In Time</strong><br />
                        {{ this.formatDateTimeFromUTC(selectedItem.checked_in_time) }}
                    </b-col>
                    <b-col sm="6">
                        <strong>Checked Out Time</strong><br />
                        {{ this.formatDateTimeFromUTC(selectedItem.checked_out_time) }}<br />
                    </b-col>
                </b-row>

                <strong>Issues on Shift</strong>
                <b-row>
                    <b-col sm="12">
                        <p v-if="!selectedItem.issues || !selectedItem.issues.length">
                            No issues reported
                        </p>
                        <p else v-for="issue in selectedItem.issues" :key="issue.id">
                            <strong v-if="issue.caregiver_injury">The caregiver reported an injury to themselves.<br /></strong>
                            {{ issue.comments }}
                        </p>
                    </b-col>
                </b-row>

                <b-row class="with-padding-bottom" v-if="selectedItem.signature">
                    <b-col>
                        <strong>Claimant Signature</strong>
                        <div v-html="selectedItem.signature.content" class="signature"></div>
                    </b-col>
                </b-row>

                <strong>Was this Shift Electronically Verified?</strong>
                <b-row class="with-padding-bottom">
                    <b-col sm="6">
                        <span v-if="selectedItem.verified">Yes</span>
                        <span v-else>No</span>
                    </b-col>
                </b-row>

                <strong>Activities Performed</strong>
                <b-row>
                    <b-col sm="12">
                        <p v-if="!selectedItem.activities || !selectedItem.activities.length">
                            No activities recorded
                        </p>
                        <table class="table table-sm" v-else>
                            <thead>
                            <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Detail</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="activity in selectedItem.activities" :key="activity.id">
                                <td>{{ activity.code }}</td>
                                <td>{{ activity.name }}</td>
                                <td>{{ activity.value }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
            </b-container>
            <div slot="modal-footer">
                <!--<b-btn variant="default" @click="downloadSelected()"><i class="fa fa-file-pdf-o"></i> Download PDF</b-btn>-->
                <b-btn variant="primary" @click="printSelected()"><i class="fa fa-print"></i> Print</b-btn>
                <b-btn variant="default" @click="detailsModal=false">Close</b-btn>
            </div>
        </b-modal>
    </b-card>
</template>

<script>

    import FormatsDates from '../../mixins/FormatsDates';
    import FormatsNumbers from '../../mixins/FormatsNumbers';
    import PaginatedTable from '../../mixins/PaginatedTable';

    export default {

        props: ['client'],

        mixins: [ FormatsDates, FormatsNumbers, PaginatedTable ],

        data() {

            return {
                sortBy: null,
                baseUrl      : '/visit-history/shifts',

                startDate    : moment().subtract( 14, 'days' ).format( 'MM/DD/YYYY' ),
                endDate      : moment().format( 'MM/DD/YYYY' ),

                disputeModal : false,
                detailsModal : false,
                selectedItem : {},

                fields: [
                    {
                        key: 'checked_in_time',
                        label: 'Date',
                        // formatter: (value) => { return this.formatDateFromUTC(value) }
                    },
                    'clocked_in',
                    'clocked_out',
                    {
                        key: 'duration',
                        label: 'Hours'
                    },
                    {
                        key: 'invoice',
                        label: 'Invoice #',
                    },
                    'submission',
                    {
                        key: 'verified',
                        label: 'EVV',
                    },

                    // {
                    //     key: 'activities',
                    //     formatter: (value) => {
                    //         let count = 0;
                    //         return value.map(function(item) {
                    //             if (count++ === 0) { return item.name }
                    //             return ',' + item.name;
                    //         })
                    //     }
                    // },
                    {
                        key: 'caregiver',
                        formatter: (value) => { return value.name }
                    },
                    {
                        key: 'total',
                        label: 'Visit Total',
                        formatter: (value) => { return this.moneyFormat(value) }
                    },
                    {
                        key: 'visit_status',
                        label: 'Visit Status',
                    },
                    {
                        key: 'flags',
                        sortable: false,
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'                        
                    }
                ],
            }
        },

        computed: {
            appliedFilters(){ 
                let dateFormat = 'YYYY-MM-DD';
                let startDate  = moment(this.startDate, 'MM/DD/YYYY').format(dateFormat,);
                let endDate    = moment(this.endDate, 'MM/DD/YYYY').format(dateFormat);
                return `?start_date=${startDate}&end_date=${endDate}`; 
            },
            startDateValid() {
                return moment(this.startDate, 'MM/DD/YYYY', true).isValid();
            },
            endDateValid() {
                 return  moment(this.endDate, 'MM/DD/YYYY', true).isValid();
            },
            hasInvalidDate() {
                return !(this.startDateValid && this.endDateValid);   
            },


        },

        methods: {

            async loadTable() {

                this.loading   = true;
                let offset     = encodeURIComponent(this.getLocalTimezoneOffset());

                if (this.startDateValid && this.endDateValid) {
                    const response = await axios.get( `${this.baseUrl}${this.appliedFilters}&offset=${offset}${this.paginationControls}` );
                    this.items     = response.data.results;
                    this.totalRows = response.data.total;
                    this.loading   = false;
                } else {
                    this.loading = false;
                    return;
                }
            },

            start_end(data) {

                if (data.item.week) {

                    if ('start' in data.item.week) {
                        return `${this.formatDate(data.item.week.start)} - ${this.formatDate(data.item.week.end)}`;
                    }
                }
                return 'Shift N/A';
            },

            printSelected() {
                $("#detailsModal .container-fluid").print();
            },

            downloadSelected() {
                let url = '/business/shifts/' + this.selectedItem.id + '/print?type=pdf';
                window.location = url;
            },

            details(item) {
                this.selectedItem = Object.assign({}, item);
                this.detailsModal = true;
            },



            formatSubmission(item) {
                if (!item.invoice || !item.invoice.submitted_at) {
                    return 'Pending';
                }
                return this.formatDateFromUTC(item.invoice.submitted_at);
            },

            determineDisplayTotal(item) {
                //console.debug("Running Determine Display Total", item);
                let visit_total = 0.00;

                if (item.shift_in_invoices > 0) {
                    visit_total = item.total;
                } else if (!item.has_adls) {
                    visit_total = 0
                } else if (!item.under_24_hours) {
                    visit_total = 0
                } else {
                    visit_total = item.total
                }

                return this.moneyFormat(visit_total)
            },

            determineVisitStatus(item) {
                if (item.shift_in_invoices > 0) {
                    return "Complete"
                }

                if (item.under_24_hours && item.has_adls) {
                    return "Complete"
                }

                if (!item.under_24_hours) {
                    return "Requires Attention"
                }

                if (!item.has_adls) {
                    return "Requires Attention"
                }

                return "Complete"
            },
            
            calculateTimeDifference(checked_in_time, checked_out_time) {
                if (!checked_in_time || !checked_out_time) return 'Invalid times';

                const checkIn = new Date(checked_in_time);
                const checkOut = new Date(checked_out_time);

                const diff = checkOut - checkIn;

                // Calculate hours and minutes
                const hours = Math.floor(diff / 3600000);
                const minutes = Math.floor((diff % 3600000) / 60000);

                return `${hours} hr ${minutes} min`;
            },
        }
    }
</script>
